import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('filled', 'crop-1-1-filled', 'Crop11Filled', [["path",{"d":"M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3z"}]]);